<template>
    <div class="topbar_user">
        <VDropdown
            :prevent-overflow="false"
            :overflow-padding="60"
            auto-boundary-max-size
            placement="bottom-end"
            theme="profileMenu"
            :positioning-disabled="isMobile"
            @apply-show="onShow()"
            @apply-hide="onHide()"
        >
            <img class="topbar_user__img cursor-pointer" :src="userData.image_path" :alt="altText" />
            <template #popper="{ hide }">
                <div class="top_user__drop">
                    <div class="user_details">
                        <img :src="userData.image_path" alt="" class="user_img" />
                        <h2 class="user_name">{{ userData.first_name }} {{ userData.surname }}</h2>
                        <p class="user_designation">{{ userData.job_title }}</p>
                        <p class="user_email">{{ userData.email }}</p>
                    </div>
                    <div class="switch_space">
                        <h2 class="workspace_title">SWITCH WORKSPACE</h2>
                        <label v-for="(item, index) in allWorkspaces" :key="index" class="work_label">
                            <input
                                :id="workspaceValue"
                                v-model="workspaceValue"
                                class="formkit-input"
                                type="radio"
                                name="radio_1"
                                :value="item.client_portal_url"
                                @click="ChangeWorkSpace(item)"
                            />
                            {{ item.client_portal_url }}
                        </label>
                    </div>
                    <div class="action_btn">
                        <a href="#" @click="(hide(), openProfile())">
                            <fa :icon="['fal', 'user-pen']" /> <span>Edit profile</span>
                        </a>
                        <router-link to="/setting/general" @click="hide()">
                            <fa :icon="['fal', 'gear']" /> <span>Settings</span>
                        </router-link>
                        <a @click.prevent="logoutUser">
                            <fa :icon="['fal', 'right-from-bracket']" /><span> Sign out</span>
                        </a>
                    </div>
                </div>
            </template>
        </VDropdown>
    </div>
</template>

<script setup>
// Vue router import
import { useRouter } from "vue-router";

// Modal import
import useToggleModal from "@/composables/useToggleModal";

// API services imports
import { logout } from "@/api/AuthServices";
import { getAgencyWorkSpaces } from "@/api/AuthServices";
// Pinia import
import { useAuthStore } from "@/stores/auth";
import { useWorkSpacesStore } from "@/stores/workSpacesStore";
import { getWorkSpace } from "@/api/WorkspaceServices";
import { getUser } from "@/api/UserServices";

import { ref } from "vue";
import { onMounted, watch } from "vue";
import { useTenantStore } from "@/stores/tenant";
import { useThemeSwitcher, useScreenSize } from "@/composables/globals";
const isMobile = ref(false);

const isScreenSize = useScreenSize();
const onShow = () => {
    if (isScreenSize.screenSize.value === "xs") {
        isMobile.value = true;
        document.body.classList.add("no-scroll");
    }
};
const onHide = () => {
    if (isScreenSize.screenSize.value === "xs") {
        isMobile.value = false;
        document.body.classList.remove("no-scroll");
    }
};

const { showTheme } = useThemeSwitcher();
const emit = defineEmits(["openProfile"]);

defineProps({
    src: {
        type: String,
        default: "",
    },
    altText: {
        type: String,
        default: "User img",
    },
});

const authStore = useAuthStore();
const router = useRouter();
const userData = ref([]);
const { toggleModal } = useToggleModal();
const workspaceStore = useWorkSpacesStore();
const allWorkspaces = ref("");
const workspaceValue = ref("");
const tenantStore = useTenantStore();

onMounted(async () => {
    getWorkSpaceMethod();
    getWorkspaces();
    workspaceValue.value = tenantStore.tenant.client_portal_url + import.meta.env.VITE_APP_BASE_DOMAIN;
});

watch(
    () => authStore.authUser,
    (newVal, oldVal) => {
        userData.value = newVal;
    },
    { deep: true },
);

const openProfile = () => {
    emit("openProfile");
};

const getWorkSpaceMethod = async () => {
    // await getWorkSpace().then((response) => {
    //     tenantStore.setTenant(response.data.tenant);
    //     authStore.setAuthUser(response.data.user);
    //     getUserMethod(response.data.user.id);
    // }).catch((e) => {
    //     console.log(e);
    // })
    try {
        const response = await getWorkSpace();
        if (response) {
            tenantStore.setTenant(response.data.tenant);
            authStore.setAuthUser(response.data.user);
            getUserMethod(response.data.user.id);
        }
    } catch (e) {
        console.log(e);
    }
};

const getUserMethod = async (id) => {
    try {
        const response = await getUser(id);
        if (response && response.code === 200) {
            userData.value = response.data.user;
            authStore.setUser(response.data.user);
            localStorage.setItem("theme_mode", response.data.user.appearance);
            showTheme();
        }
    } catch (e) {
        console.log(e);
    }
};

const logoutUser = async () => {
    const response = await logout();

    if (response.code === 200) {
        toggleModal();
        localStorage.clear();
        window.location = `${import.meta.env.VITE_APP_DOMAIN}/login`;
    }
};

const getWorkspaces = async () => {
    getAgencyWorkSpaces().then((response) => {
        workspaceStore.setUserWorkSpace(response.data.tenants);
        allWorkspaces.value = response.data.tenants;
    });
};

const ChangeWorkSpace = (value) => {
    workspaceValue.value = value.client_portal_url;
    let workSpaceName = workspaceValue.value.split(".")[0];

    router.push("/dashboard").then(() => {
        window.location.hostname = `${value.client_portal_url}`;
    });
    getWorkSpace(workSpaceName);
};
</script>

<style scoped>
.topbar_user {
    @apply h-8 w-8 sm:h-10 sm:w-10 rounded-full;
}
input[type="radio"] {
    appearance: none;
    width: 24px;
    height: 24px;
    border: 1px solid #dcdedf;
    border-radius: 50%;
    position: relative;
    top: 6px;
    left: -5px;
    background-clip: content-box;
    background-color: #f1f5f7;
}

input[type="radio"]:checked {
    width: 24px;
    height: 24px;
    position: relative;
    top: 6px;
    left: -5px;
    background-color: #000;
    padding: 6px;
}
.topbar_user__img {
    @apply h-8 w-8 sm:w-10 sm:h-10 object-cover rounded-full;
}
.top_user__drop {
    @apply p-4 pt-8 bg-white rounded drop-shadow-[0_0.25rem_0.75rem_rgba(0,0,0,0.25)] dark:bg-dm-whitebg dark:shadow-userdropdown;
}

.user_details {
    @apply text-center leading-5 mb-8;
}
.user_img {
    @apply rounded-full w-[7.5rem] h-[7.5rem] max-w-full m-auto mb-2 object-cover;
}
.user_name {
    @apply text-base text-black-900 font-medium mb-2 dark:text-dm-white;
}
.user_designation {
    @apply text-sm text-black-900 font-normal mb-2 dark:text-dm-white;
}
.user_email {
    @apply text-sm text-black-900 font-normal dark:text-dm-white;
}
.switch_space {
    @apply border-t border-b py-5 dark:border-black-900;
}
.workspace_title {
    @apply text-gray-300 font-bold text-xs pl-2 dark:text-dm-white;
}
.work_label {
    @apply block italic text-sm font-normal pt-3 pb-0 px-3 text-dark-100 dark:text-dm-white cursor-pointer;
}
/* .work_label:hover{
    @apply bg-gray-100 rounded-lg cursor-pointer dark:bg-black;
} */
.work_rad {
    @apply mr-2;
}
.action_btn {
    @apply pt-3;
}
.action_btn a {
    @apply block text-sm italic text-dark-100 py-[0.625rem] px-2 dark:text-dm-white;
}
.action_btn a span {
    @apply align-middle;
}
.action_btn a:hover {
    @apply bg-gray-100 rounded-lg cursor-pointer dark:bg-black-900;
}
.action_btn svg {
    @apply text-gray-300 text-lg align-middle dark:text-black-900;
}
/* .action_btn a:last-child{
    @apply  mb-0;
} */
</style>
